import React from 'react';
import { AssignmentPassage } from '../../../state/assignment-edit.types';
import QuestionRenderer from './QuestionRenderer';
import { makeStyles } from '@material-ui/core/styles';
import colors from '../../../../../../../styles/colors';
import { Box, Grid, IconButton } from '@material-ui/core';
import { useAppSelector } from '../../../../../../../redux/hooks';
import { DeleteOutlined, EditOutlined } from '@material-ui/icons';
interface PassageRendererProps {
  passageData: AssignmentPassage;
  handleQuestionIndex: any;
  isEditable?: boolean;
  handleDeleteQuestion: any;
  setQuestionEditMode?: any;
  showDelete?: boolean;
}

const useStyles = makeStyles({
  root: {
    border: `1px solid ${colors.assignment.grey}`,
    borderRadius: '4px'
  },
  padding: {
    padding: '1.2rem'
  },
  header: {
    backgroundColor: colors.assignment.grey,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  list: {
    listStyle: 'none'
  },
  round: {
    marginRight: '10px',
    borderRadius: '50%',
    width: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '20px',
    border: `1px solid ${colors.assignment.grey}`
  },
  textLine: {
    width: '100%',
    textAlign: 'left',
    borderBottom: `1px solid ${colors.assignment.grey}`,
    lineHeight: '0.1em',
    margin: '10px 0 20px'
  },
  text: {
    background: '#fff',
    padding: '0 10px',
    fontSize: '12px',
    marginLeft: '20px',
    color: `${colors.assignment.grey}`
  }
});

const PassageRenderer = (props: PassageRendererProps) => {
  const {
    passageData,
    handleQuestionIndex,
    isEditable,
    showDelete,
    handleDeleteQuestion,
    setQuestionEditMode
  } = props;
  const { questions } = passageData;
  const classes = useStyles();
  const genres = useAppSelector(state => state.editAssignment.genres);
  const index = handleQuestionIndex(passageData.id);
  const genre = genres.filter(genre => genre.id === passageData.genreId)[0];
  const filteredQuestions = questions.filter(question => !question.isDeleted);
  return (
    <Grid container className={classes.root}>
      <Grid item xs={12} className={`${classes.padding} ${classes.header}`}>
        <span>
          Passage {index} - {genre?.name}
        </span>
        <Box>
          {isEditable && (
            <IconButton onClick={() => setQuestionEditMode(passageData.id)}>
              <EditOutlined />
            </IconButton>
          )}
          {showDelete && (
            <IconButton
              onClick={() => handleDeleteQuestion(null, passageData.id)}
            >
              <DeleteOutlined />
            </IconButton>
          )}
        </Box>
      </Grid>
      <Grid item xs={12} className={classes.padding}>
        <span>{passageData.passageTitle}</span>
    {passageData.imgUrl && (
        <p>
          <img style={{maxWidth: '30rem', maxHeight: '30rem', width:'100%'}} src={passageData.imgUrl}/>
        </p>
    )}
        <span dangerouslySetInnerHTML={{ __html: passageData.passage }} />
      </Grid>
      <Grid item xs={12} style={{ padding: '1rem' }}>
        {filteredQuestions?.map((questionData: any) => (
          <Box padding={'10px'} key={questionData.id}>
            <QuestionRenderer
              setQuestionEditMode={setQuestionEditMode}
              isEditable={isEditable}
              rootId={passageData.id}
              isPassageQuestion={true}
              showDelete={showDelete}
              handleDeleteQuestion={handleDeleteQuestion}
              handleQuestionIndex={handleQuestionIndex}
              question={questionData}
            />
          </Box>
        ))}
      </Grid>
    </Grid>
  );
};

export default PassageRenderer;
